// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"c4bcb093","380":"c91ef758","592":"de2fa571","720":"fb4634c4"}[chunkId] + ".chunk.css";
};